import { S25Datefilter } from "../../s25-dateformat/s25.datefilter.service";
import { S25Util } from "../../../util/s25-util";

/** `<input type="date">` requires yyyy-MM-dd. GDA LocalDateTime is yyyy-MM-ddTHH:mm:ss. */
export function toDateInputValue(value: string | undefined | null): string {
    return S25Util.date.toCivilDateString(value) ?? "";
}

/** `<input type="datetime-local">` requires yyyy-MM-ddTHH:mm. GDA LocalDateTime includes seconds. */
export function toDateTimeLocalValue(value: string | undefined | null): string {
    if (value == null || value === "") return "";
    const dateTimeLocal = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/.exec(value);
    return dateTimeLocal?.[1] ?? "";
}

export function formatUserprefDate(
    value: string | Date | number | undefined | null,
    format: string | undefined,
    empty = "—",
): string {
    if (value == null || value === "") return empty;
    if (!format) return empty;
    return S25Datefilter.transform(value, format) ?? empty;
}
